import { render, staticRenderFns } from "./LifetimeFaqSection.vue?vue&type=template&id=34f347dc&scoped=true"
import script from "./LifetimeFaqSection.vue?vue&type=script&lang=js"
export * from "./LifetimeFaqSection.vue?vue&type=script&lang=js"
import style0 from "./LifetimeFaqSection.vue?vue&type=style&index=0&id=34f347dc&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f347dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/dev.ideabuddy.com/public_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34f347dc')) {
      api.createRecord('34f347dc', component.options)
    } else {
      api.reload('34f347dc', component.options)
    }
    module.hot.accept("./LifetimeFaqSection.vue?vue&type=template&id=34f347dc&scoped=true", function () {
      api.rerender('34f347dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Payment/Components/Sections/Faq/LifetimeFaqSection.vue"
export default component.exports